import { useEffect, useState } from 'react'
import {
  getNativeClientPlatformStats,
  getNativeClientPlatforms,
} from '@/services/native-client-platform.js'

function getAgents(client) {
  return client?.agents ?? client?.assistants ?? []
}

export function useClientHealth() {
  const [health, setHealth] = useState({
    stats: { total: 0, active: 0, withPlan: 0 },
    clients: [],
    pendingClients: [],
    agents: 0,
  })
  const [loading, setLoading] = useState(true)

  useEffect(() => {
    let active = true
    setLoading(true)

    Promise.all([
      getNativeClientPlatformStats(),
      getNativeClientPlatforms({ page: 1, perPage: 100 }),
    ])
      .then(([statsResponse, clientsResponse]) => {
        if (!active) return
        const clients = clientsResponse?.data ?? []
        const pendingClients = clients.filter((client) => getAgents(client).length === 0)
        setHealth({
          stats: statsResponse?.data ?? { total: clients.length, active: 0, withPlan: 0 },
          clients,
          pendingClients,
          agents: clients.reduce((total, client) => total + getAgents(client).length, 0),
        })
      })
      .catch(() => {
        if (active) {
          setHealth((current) => ({ ...current, clients: [], pendingClients: [] }))
        }
      })
      .finally(() => {
        if (active) setLoading(false)
      })

    return () => {
      active = false
    }
  }, [])

  return { health, loading }
}
